import React from "react";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Select } from "antd";
import "antd/dist/antd.css";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/unittaskconfiguration/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.unittaskconfiguration.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_ASYNC]: { done: this._handleSaveAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        this.props.loadScreenViewAsync(id);
    }

    render() {

        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) {
            return <LoadingIndicator />;
        }

        const { configuration, users, taskTypes } = this.props.localState;
        const { /*id,*/ name, participants } = configuration;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{this.props.t("unittaskconfiguration")}</h3>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button
                                                color="info"
                                                onClick={this._handleSave}
                                                disabled={this.isActionExecuting(ActionTypes.SAVE_ASYNC)}
                                                size="sm">
                                                {this.props.t("save")}
                                            </Button>&nbsp;
                                            <Button
                                                color="default"
                                                onClick={this._handleCancel}
                                                disabled={this.isActionExecuting(ActionTypes.SAVE_ASYNC)}
                                                size="sm">
                                                {this.props.t("cancel")}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">{this.props.t("name")}</label>
                                                    <Select
                                                        size="large"
                                                        style={{ width: '100%' }}
                                                        placeholder={`${this.props.t("select")} ${this.props.t("name")}`}
                                                        defaultValue={this.localVars.navParams.id ? this.props.t(name) : []}
                                                        onChange={val => this.props.selectTaskType(val)}
                                                        optionFilterProp="label"
                                                        disabled={this.localVars.navParams.id}
                                                    >
                                                        {taskTypes.map((taskType, i) => <Select.Option value={taskType.id}>{this.props.t(taskType.name)}</Select.Option>)}
                                                    </Select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">{this.props.t("participants")}</label>
                                                    <Select
                                                        mode="multiple"
                                                        size="large"
                                                        style={{ width: '100%' }}
                                                        placeholder={`${this.props.t("select")} ${this.props.t("participants")}`}
                                                        defaultValue={participants ? participants.split(",") : []}
                                                        onChange={val => this.props.setParticipants(val)}
                                                        optionFilterProp="label"
                                                    >
                                                        {users.map(u => {
                                                            return <Select.Option value={u.id} label={`${u.fullName} (${u.email})`}>{`${u.fullName} (${u.email})`}</Select.Option>
                                                        })}

                                                    </Select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancel = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSave = () => {
        const { configuration } = this.props.localState;
        if (!configuration.id) {
            this.displayError({ message: this.props.t("fieldIsRequired", { field: this.props.t("name") }) });
        }
        else if (!configuration.participants) {
            this.displayError({ message: this.props.t("fieldIsRequired", { field: this.props.t("participants") }) });
        } else {
            this.props.saveAsync(configuration);
        }
    }

    _handleSaveAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        selectTaskType: val => dispatch(Actions.selectTaskType(val)),
        setParticipants: val => dispatch(Actions.setParticipants(val)),
        saveAsync: vo => dispatch(Actions.saveAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));